import React from 'react';
import ChartistGraph from 'react-chartist';
import "./chartist.min.css";
import "./angle-over-time-chart.css";

class AngleOverTimeChart extends React.Component {
    render() {
        const anglesOverTimeData = this.props.angles_over_time_data;
        if (!anglesOverTimeData) {
            return (
                <div className='chart-spinner-container'>
                    <i className='fa fa-spinner fa-spin'/>
                </div>
            );
        }
        const chartData = prepareChartData(anglesOverTimeData);

        const graphDataParsed = {
          labels: chartData.dates,
          series: [chartData.pronation_values, chartData.supination_values]
        };

        const options = {
            low: 0,
            high: 90,
            showLabels: true
        };

        const type = 'Line';

        return (
              <div>
                  <div>Over Time</div>
                  <div className='angles_over_time_charts_container'>
                    <ChartistGraph data={graphDataParsed} options={options} type={type}/>
                    <div className='angle_over_time_legend'>
                      <span className='legend_text'><span className='legend_rect supination'></span>Supination</span>
                      <span className='legend_text'><span className='legend_rect pronation'></span>Pronation</span>
                    </div>
                  </div>
              </div>

        )
    }
}

function prepareHandData(handData) {
  var parsedData = {
    dates: [],
    pronation_values: [],
    supination_values: []
  };
  var currentData;
  for (var i = 0; i < handData.length; i++) {
    currentData = handData[i];
    parsedData.dates.push(currentData.date.substring(5));
    parsedData.pronation_values.push(currentData.pronation_max);
    parsedData.supination_values.push(currentData.supination_max);
  }

  return parsedData;
}

function prepareChartData(anglesOverTimeData) {
    var handData = prepareHandData(anglesOverTimeData);


    return handData;
}

export default AngleOverTimeChart;



// WEBPACK FOOTER //
// ./src/components/components/player-overview-charts/angle_over_time_chart.js